import { motion } from "framer-motion";

const MINUTE = 60;
const HOUR = 3600;
const DAY = 86400;

function timeAgo(iso) {
  const t = new Date(iso).getTime();
  const diff = (Date.now() - t) / 1000;
  if (diff < MINUTE) return "just now";
  if (diff < HOUR) return `${Math.floor(diff / MINUTE)}m ago`;
  if (diff < DAY) return `${Math.floor(diff / HOUR)}h ago`;
  return `${Math.floor(diff / DAY)}d ago`;
}

export default function ActivityFeed({ items }) {
  return (
    <section
      className="bg-white border border-[#DCE0D9] p-7"
      data-testid="activity-card"
    >
      <p className="tracker text-[10px] text-[#5C6B61]">The Ledger</p>
      <h2 className="font-display text-3xl text-[#1A2F24] mt-1">
        What&apos;s stirring
      </h2>

      {items.length === 0 ? (
        <p
          className="font-body text-sm text-[#5C6B61] mt-6"
          data-testid="activity-empty"
        >
          Quiet so far. New bookings will land here.
        </p>
      ) : (
        <ol className="mt-6 space-y-5">
          {items.slice(0, 10).map((a, i) => (
            <motion.li
              key={a.id}
              initial={{ opacity: 0, x: -4 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.04 * i }}
              className="flex gap-3"
              data-testid={`activity-row-${a.id}`}
            >
              <span
                className="mt-1.5 inline-block h-2 w-2 shrink-0 rounded-full"
                style={{ background: a.color || "#1A2F24" }}
              />
              <div className="flex-1 min-w-0">
                <p className="font-body text-sm text-[#1A2F24] leading-snug">
                  {a.detail}
                </p>
                <p className="tracker text-[9px] text-[#5C6B61] mt-1">
                  {timeAgo(a.created_at)}
                </p>
              </div>
            </motion.li>
          ))}
        </ol>
      )}
    </section>
  );
}
